// If the API doesn't respond, we use these fallback reasons
export const FALLBACK_REASONS = [
  {
    "@id": "/reason_for_refusals/event_absence_medical",
    key: "event_absence_medical",
    value: "Raison médicale",
  },
  {
    "@id": "/reason_for_refusals/event_absence_personal",
    key: "event_absence_personal",
    value: "Raison personnelle",
  },
];
